import { render, staticRenderFns } from "./UpdateValuesDialog.vue?vue&type=template&id=64056794&scoped=true"
import script from "./UpdateValuesDialog.vue?vue&type=script&lang=js"
export * from "./UpdateValuesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64056794",
  null
  
)

export default component.exports